
var app ={};
var subPub1 = Object.seal({
    key: 0,
    subscribers: {},
    subscribe: function (subscriber) {
        console.log("Keyboard down Subscriber added, Total: ",Object.keys(this.subscribers).length+1)
        this.subscribers[this.key] = subscriber;
        return this.key++;
    },
    publish: function (args) {
        console.log("publishing",{...args})
        let {isTrusted,key}=args;
        for (var sub in this.subscribers) {
            // console.log("publishing for key",sub)
            try {
                this.subscribers[sub]({isTrusted,key});
            } catch (ignore) {
                console.log("running subs  error",ignore)
             }
        }
    },
    unsubscribe: function (key) {
        delete this.subscribers[key];
    },
});




var subPub2 = Object.seal({
    key: 0,
    subscribers: {},
    subscribe: function (subscriber) {
        console.log("Keyboard up Subscriber added, Total: ",Object.keys(this.subscribers).length+1)
        
        this.subscribers[this.key] = subscriber;

        return this.key++;
    },
    publish: function (args) {
        // console.log("publishing",{...args})
        let {isTrusted,key}=args;
        for (var sub in this.subscribers) {
            // console.log("publishing for key",sub)
            try {
                // console.log(this.subscribers[sub],"THIS IS FUNCTION TO BE CALLED",typeof this.subscribers[sub])
                this.subscribers[sub]({isTrusted,key});
                // console.log("runned")
            } catch (ignore) {
                console.log("running subs  error",ignore)
             }
        }
    },
    unsubscribe: function (key) {
        // console.log("unsubscribing",key)
        delete this.subscribers[key];
    },
});

app['keydown'] = Object.create(subPub1);
app['keyup']=Object.create(subPub2);



// class EventSubscriber {
//     startListen = () => {
//         app['keydown'] = Object.create(subPub);
//         app['keyup']=Object.create(subPub);
//     }
// }

function getApp(){
    return app;
}


class MainListener {
    constructor(props) {
    
    //    new EventSubscriber().startListen()
    }

    
     initialize = () => {
        window.addEventListener('keydown', (e) => {
            app=getApp();
            app.keydown.publish(e);
        })
        window.addEventListener('keyup', (e) => {
            app=getApp()
            app.keyup.publish(e);
        })
    }
}

export {MainListener,getApp}